import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { WorkshopDefect } from '../../models/workshop-defect.model';
import { WorkshopInvoicingService } from '../../services/workshop-invoicing.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-workshop-invoicing',
    templateUrl: './workshop-invoicing.component.html',
    styleUrls: ['./workshop-invoicing.component.scss'],
    standalone: false
})
export class WorkshopInvoicingComponent implements OnInit {

  defects: WorkshopDefect[] = [];
  selectedIds: Set<number> = new Set();

  isServerError: boolean = false;
  serverErrorMessage: string = '';
  isSuccess: boolean = false;

  constructor(private workshopInvoicingService: WorkshopInvoicingService) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.workshopInvoicingService.getUninvoicedCompletedDefects()
    .pipe(take(1))
    .subscribe((defects: WorkshopDefect[]) => {
      this.defects = defects;
      this.selectedIds.clear();
    });
  }

  partsTotal(defect: WorkshopDefect): number {
    return (defect.parts || []).reduce((total, part) => total + (part.qty * (part.unitPrice || 0)), 0);
  }

  labourTotal(defect: WorkshopDefect): number {
    return (defect.fitterAssignments || [])
      .filter(a => a.hours && a.fitter && a.fitter.hourlyRate)
      .reduce((total, a) => total + (a.hours * a.fitter.hourlyRate), 0);
  }

  isSelected(defect: WorkshopDefect): boolean {
    return this.selectedIds.has(defect.id);
  }

  toggleSelected(defect: WorkshopDefect): void {
    if(this.selectedIds.has(defect.id)) {
      this.selectedIds.delete(defect.id);
    } else {
      this.selectedIds.add(defect.id);
    }
  }

  raiseInvoices(): void {
    this.isServerError = false;
    this.isSuccess = false;

    if(this.selectedIds.size === 0) {
      return;
    }

    this.workshopInvoicingService.assignWorkshopDefects(Array.from(this.selectedIds))
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401){return e;}
      this.isServerError = true;
      this.serverErrorMessage = e && e.error && e.error.message ? e.error.message : 'Something went wrong. Please try again later.';
      return e;
    }))
    .subscribe((result) => {
      if(result instanceof HttpErrorResponse) {
        return;
      }
      this.isSuccess = true;
      this.load();
    });
  }

}
